import React, { Component } from 'react';
import { connect } from 'react-redux';
import { generateId } from './../../utils';
import { addTask, editTask, formEditable } from "./../../actions";
import './addTaskForm.scss';

class AddTaskForm extends Component {
    state = {
        'buttonTitle': '+'
    };
    taskTitle = null;
    taskDescription = null;
    buttonTitle = null;

    submit = () => {
        if (!this.taskTitle.value) {
            this.taskTitle.focus();
        } else if (!this.props.editStatus) {
            this.props.addTask(this.taskTitle.value, this.taskDescription.value);
        } else {
            this.props.editTask(this.taskTitle.value, this.taskDescription.value, this.props.taskDetails.id);
            this.props.editable(false);
        }
        this.taskTitle.value = null;
        this.taskDescription.value = null;
    };
    componentWillReceiveProps(nextProps) {
        this.taskTitle.value = nextProps.taskDetails ? nextProps.taskDetails.title : null;
        this.taskDescription.value = nextProps.taskDetails ? nextProps.taskDetails.description : null;
        this.setState({...this.state, 'buttonTitle': nextProps.editStatus ? 'save' : '+'});
    }
    render() {
        return (
            <div className='todo-form card m-2 bg-light'>
                <div className='card-body'>
                    <div className="form-group d-flex justify-content-center mt-3 title">
                        <input className='form-control'
                               placeholder='Title'
                               ref={node => this.taskTitle = node}
                        />
                        <button className='btn btn-primary btn-form' onClick={this.submit}
                                ref={node => this.buttonTitle = node}
                        >
                            {this.state.buttonTitle}
                        </button>
                    </div>
                    <div className='form-group form-inline justify-content-center description'>
                        <input className='form-control'
                               placeholder='Description'
                               ref={node => this.taskDescription = node}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        editStatus: state.editable,
        taskDetails: state.taskDetails
    }),
    dispatch => ({
        'addTask': (taskTitle, taskDescription) => {
            dispatch(addTask(taskTitle, taskDescription, generateId()));
        },
        'editTask': (title, description, id) => {
            dispatch(editTask(title, description, id))
        },
        'editable': bool => {
            dispatch(formEditable(bool))
        }
    })
)(AddTaskForm);